import * as React from 'react';
import { MetricaProvider } from '@sorpetaler/ui/src/context/MetricaContext';
import { SiteConfigProvider } from '@sorpetaler/ui/src/context/SiteConfigContext';
import { WidgetBlockProvider } from '@sorpetaler/ui/src/context/WidgetBlockContext';
import { deWidgetBlockRenderers } from './de-widget-block-renderers';
import { deSiteConfig } from './site-config';

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => (
  <SiteConfigProvider config={deSiteConfig}>
    <MetricaProvider>
      <WidgetBlockProvider renderers={deWidgetBlockRenderers}>
        {element}
      </WidgetBlockProvider>
    </MetricaProvider>
  </SiteConfigProvider>
);
